import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import DispositionDetail from 'src/app/interfaces/disposition-detail';
import DispositionGpTransferStatus from 'src/app/interfaces/disposition-gp-transfer-status';
import DispositionRefinancingStatus from 'src/app/interfaces/disposition-refinancing-status';
import ProjectDetail from 'src/app/interfaces/project-detail';
import {
  CREATE_DISPOSITION_DETAILS,
  GET_DISPOSITION_DETAILS,
  UPDATE_DISPOSITION_DETAILS,
  UpdateDispositionDetailInput,
} from './graphql/dispositions-details';
import Project from 'src/app/interfaces/project';
import { UPDATE_DISPOSITION } from 'src/app/deals/deal-dispositions/graphql/dispositions';
import { User } from '../../interfaces/user';
import { AlertService } from '../../alert/alert.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

const config = new MatSnackBarConfig();
config.panelClass = ['save-success'];
config.horizontalPosition = 'center';
config.verticalPosition = 'top';
config.duration = 3000;
@Injectable({
  providedIn: 'root',
})
export class DispositionsDetailsService {
  private _dispositionDetail: DispositionDetail | null = null;
  private dispositionDetail = new BehaviorSubject(this._dispositionDetail);
  public dispositionDetail$ = this.dispositionDetail.asObservable();

  private _projectDetail: ProjectDetail | null = null;
  private projectDetail = new BehaviorSubject(this._projectDetail);
  public projectDetail$ = this.projectDetail.asObservable();

  private _dispositionGpTransferStatuses: DispositionGpTransferStatus[] = [];
  private dispositionGpTransferStatuses = new BehaviorSubject(
    this._dispositionGpTransferStatuses
  );
  public dispositionGpTransferStatuses$ =
    this.dispositionGpTransferStatuses.asObservable();

  private _dispositionRefinancingStatuses: DispositionRefinancingStatus[] = [];
  private dispositionRefinancingStatuses = new BehaviorSubject(
    this._dispositionRefinancingStatuses
  );
  public dispositionRefinancingStatuses$ =
    this.dispositionRefinancingStatuses.asObservable();

  constructor(
    public apollo: Apollo,
    private alert: AlertService,
    private _snackBar: MatSnackBar
  ) {}

  public getDispositionDetail(project_id: string) {
    let sub = this.apollo
      .watchQuery({
        query: GET_DISPOSITION_DETAILS,
        variables: { project_id },
      })
      .valueChanges.subscribe(({ data, loading }) => {
        if(data){
          let {
            getDispositionDetail,
            getProjectDetail,
            getDispositionGpTransferStatuses,
            getDispositionRefinancingStatuses,
            me,
          } = data as {
            getDispositionDetail: DispositionDetail | null;
            getProjectDetail: ProjectDetail;
            getDispositionGpTransferStatuses: DispositionGpTransferStatus[];
            getDispositionRefinancingStatuses: DispositionRefinancingStatus[];
            me: User;
          };
          if (!getDispositionDetail && !!me.permissionsForResource?._create) {
            //if (true){
            this.initDispositionDetail(project_id);
          } else {
            this._dispositionDetail = getDispositionDetail;
            this.dispositionDetail.next(this._dispositionDetail);
          }
          this._projectDetail = getProjectDetail;
          this._dispositionGpTransferStatuses = getDispositionGpTransferStatuses;
          this._dispositionRefinancingStatuses =
            getDispositionRefinancingStatuses;

          this.projectDetail.next(this._projectDetail);
          this.dispositionGpTransferStatuses.next(
            this._dispositionGpTransferStatuses
          );
          this.dispositionRefinancingStatuses.next(
            this._dispositionRefinancingStatuses
          );
          sub?.unsubscribe();

        }
      });
  }
  public initDispositionDetail(project_id: string) {
    let sub = this.apollo
      .mutate({
        mutation: CREATE_DISPOSITION_DETAILS,
        variables: { project_id },
      })
      .subscribe(({ data, loading }) => {
        let { createDispositionDetail } = data as {
          createDispositionDetail: DispositionDetail;
        };
        this._dispositionDetail = createDispositionDetail;
        this.dispositionDetail.next(this._dispositionDetail);
        sub?.unsubscribe();
      });
  }
  public updateDispositionDetail(
    disposition_detail_id: string,
    disposition_detail_input: UpdateDispositionDetailInput,
    project_detail_id: string,
    project_detail_input: { fully_disposed: boolean | null }
  ) {
    let sub = this.apollo
      .mutate({
        mutation: UPDATE_DISPOSITION_DETAILS,
        variables: {
          disposition_detail_id,
          disposition_detail_input,
          project_detail_id,
          project_detail_input,
        },
      })
      .subscribe(({ data, loading }) => {
        let { updateDispositionDetail, updateProjectDetail } = data as {
          updateDispositionDetail: DispositionDetail;
          updateProjectDetail: ProjectDetail;
        };

        this._dispositionDetail = updateDispositionDetail;
        this._projectDetail = updateProjectDetail;

        this.dispositionDetail.next(this._dispositionDetail);
        this.projectDetail.next(this._projectDetail);
        this._snackBar.open(
          'Disposition details saved successfully',
          'Ok',
          config
        );
        sub?.unsubscribe();
      });
  }
}
